function ElSalvador({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_521_1116)">
        <path d="M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z" fill="#F0F0F0"/>
        <path d="M16 0C9.65664 0 4.17565 3.69156 1.58765 9.0435H30.4123C27.8244 3.69156 22.3433 0 16 0V0Z" fill="#0052B4"/>
        <path d="M16 32C22.3433 32 27.8244 28.3085 30.4124 22.9565H1.58765C4.17565 28.3085 9.65664 32 16 32Z" fill="#0052B4"/>
        <path d="M12.7869 16.6956L16 11.1304L19.2131 16.6956H12.7869Z" fill="#FFDA44"/>
        <path d="M20.1739 18.5333L16 20.6203L11.826 18.5333V15.7507H20.1739V18.5333Z" fill="#6DA544"/>
        <path d="M19.9351 11.3691L18.4594 12.8448C19.0889 13.4743 19.4783 14.3438 19.4783 15.3043C19.4783 17.2253 17.9209 18.7826 16 18.7826C14.0791 18.7826 12.5218 17.2253 12.5218 15.3043C12.5218 14.3438 12.9111 13.4743 13.5406 12.8448L12.0649 11.3691C11.0577 12.3761 10.4348 13.7675 10.4348 15.3043C10.4348 18.378 12.9264 20.8695 16 20.8695C19.0736 20.8695 21.5652 18.3779 21.5652 15.3043C21.5651 13.7675 20.9423 12.3761 19.9351 11.3691V11.3691Z" fill="#FFDA44"/>
      </g>
    </svg>
  `;

  return baseXml;
}

export default ElSalvador;
